<template>
  <main-layout
    class="pb-2"
    small
  >
    <sent-summary-container />
  </main-layout>
</template>

<script>

import SentSummaryContainer from '@/components/Widgets/Drafts/SentSummaryContainer';

export default {

  name: 'SentDraft',
  components: {
    SentSummaryContainer,
  },
  data() {
    return {};
  },
};
</script>

<style lang="css" scoped>
</style>
